import * as React from "react";
import { cn } from "./utils";

export function Toast({
  message,
  className,
}: {
  message: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "bg-primary text-white px-4 py-2 rounded-xl shadow-md backdrop-blur-md transition-all animate-fade-in",
        className
      )}
    >
      {message}
    </div>
  );
}